var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: { actions: _vm.headerActionConfig, page: _vm.page }
      }),
      _c("filter-manager", {
        ref: "filterComponent",
        staticClass: "mb-4 c-filterManager",
        attrs: { "display-advanced": false, filters: _vm.filtersConfig },
        on: { search: _vm.onSearchHandler },
        model: {
          value: _vm.selectedFilters,
          callback: function($$v) {
            _vm.selectedFilters = $$v
          },
          expression: "selectedFilters"
        }
      }),
      _c("separator", {
        staticClass: "my-3",
        attrs: { text: "Resultado de Vigencia de Referido" }
      }),
      _c("search-result", {
        attrs: {
          "result-search": _vm.result,
          "search-academic-year-id": _vm.searchedAcademicYear
        },
        on: { "on-page-change": _vm.onPageChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }